/* ==========================================================================
   PIERCED PRINTS™ Product Page
   Gallery + Variant Selection
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initPPProductGalleries();
  initPPProductForms();
});


/* ==========================================================================
   Product Gallery
   ========================================================================== */

function initPPProductGalleries() {
  const galleries = document.querySelectorAll('[data-pp-product-gallery]');

  galleries.forEach((gallery) => {
    const thumbnails = gallery.querySelectorAll(
      '[data-pp-gallery-thumbnail]'
    );

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const mediaId = thumbnail.dataset.ppGalleryThumbnail;

        setPPGalleryMedia(gallery, mediaId);
      });
    });
  });
}


function setPPGalleryMedia(gallery, mediaId) {
  if (!gallery || !mediaId) return;

  const slides = gallery.querySelectorAll(
    '[data-pp-gallery-slide]'
  );

  const thumbnails = gallery.querySelectorAll(
    '[data-pp-gallery-thumbnail]'
  );

  slides.forEach((slide) => {
    const isActive =
      String(slide.dataset.ppGallerySlide) === String(mediaId);

    slide.classList.toggle('is-active', isActive);
  });

  thumbnails.forEach((thumbnail) => {
    const isActive =
      String(thumbnail.dataset.ppGalleryThumbnail) === String(mediaId);

    thumbnail.classList.toggle('is-active', isActive);

    if (isActive) {
      thumbnail.setAttribute('aria-current', 'true');
    } else {
      thumbnail.removeAttribute('aria-current');
    }
  });
}


/* ==========================================================================
   Product Form
   ========================================================================== */

function initPPProductForms() {
  const forms = document.querySelectorAll('[data-pp-product-form]');

  forms.forEach((container) => {
    const form = container.querySelector('form');

    if (!form) return;

    const variantDataElement = form.querySelector(
      '[data-pp-product-variants]'
    );

    if (!variantDataElement) return;

    let variants = [];

    try {
      variants = JSON.parse(variantDataElement.textContent);
    } catch (error) {
      console.error(
        'PIERCED PRINTS: Unable to read product variants.',
        error
      );

      return;
    }

    const optionInputs = form.querySelectorAll(
      '.pp-product-form__option-input'
    );

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updatePPVariant(container, form, variants);
      });
    });

    updatePPVariant(container, form, variants);
  });
}


/* ==========================================================================
   Variant Selection
   ========================================================================== */

function getPPSelectedOptions(form) {
  const optionGroups = form.querySelectorAll(
    '[data-pp-product-option]'
  );

  return Array.from(optionGroups).map((group) => {
    const checkedInput = group.querySelector(
      '.pp-product-form__option-input:checked'
    );

    return checkedInput ? checkedInput.value : null;
  });
}


function findPPVariant(variants, selectedOptions) {
  return variants.find((variant) => {
    if (!variant.options) return false;

    return variant.options.every((option, index) => {
      return option === selectedOptions[index];
    });
  });
}


function updatePPVariant(container, form, variants) {
  const selectedOptions = getPPSelectedOptions(form);

  if (selectedOptions.includes(null)) {
    updatePPAddToCart(container, null);
    return;
  }

  const variant = findPPVariant(variants, selectedOptions);

  const variantInput = form.querySelector(
    '[data-pp-variant-id]'
  );

  if (!variant) {
    if (variantInput) {
      variantInput.value = '';
    }

    updatePPAddToCart(container, null);
    updatePPProductInfo(null);

    return;
  }

  if (variantInput) {
    variantInput.value = variant.id;
  }

  updatePPAddToCart(container, variant);
  updatePPProductInfo(variant);
  updatePPVariantGallery(variant);

  updatePPProductURL(variant);
}


/* ==========================================================================
   Add to Cart State
   ========================================================================== */

function updatePPAddToCart(container, variant) {
  const button = container.querySelector(
    '[data-pp-add-to-cart]'
  );

  const buttonText = container.querySelector(
    '[data-pp-add-to-cart-text]'
  );

  if (!button || !buttonText) return;

  if (!variant) {
    button.disabled = true;
    buttonText.textContent = 'Unavailable';

    return;
  }

  if (variant.available) {
    button.disabled = false;
    buttonText.textContent = 'Add to Cart';
  } else {
    button.disabled = true;
    buttonText.textContent = 'Sold Out';
  }
}


/* ==========================================================================
   Price + Availability
   ========================================================================== */

function updatePPProductInfo(variant) {
  const price = document.querySelector(
    '[data-pp-product-price]'
  );

  const comparePrice = document.querySelector(
    '[data-pp-product-compare-price]'
  );

  const availability = document.querySelector(
    '[data-pp-product-availability]'
  );

  if (!variant) {
    if (availability) {
      availability.innerHTML = `
        <span
          class="pp-product-info__availability-dot
                 pp-product-info__availability-dot--sold-out">
        </span>

        <span>Unavailable</span>
      `;
    }

    return;
  }

  if (price) {
    price.textContent = formatPPMoney(variant.price);
  }

  if (comparePrice) {
    if (
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    ) {
      comparePrice.textContent =
        formatPPMoney(variant.compare_at_price);

      comparePrice.hidden = false;
    } else {
      comparePrice.hidden = true;
    }
  }

  if (availability) {
    if (variant.available) {
      availability.innerHTML = `
        <span
          class="pp-product-info__availability-dot">
        </span>

        <span>Available</span>
      `;
    } else {
      availability.innerHTML = `
        <span
          class="pp-product-info__availability-dot
                 pp-product-info__availability-dot--sold-out">
        </span>

        <span>Sold Out</span>
      `;
    }
  }
}


/* ==========================================================================
   Variant Gallery
   ========================================================================== */

function updatePPVariantGallery(variant) {
  if (!variant || !variant.featured_media) return;

  const gallery = document.querySelector(
    '[data-pp-product-gallery]'
  );

  if (!gallery) return;

  setPPGalleryMedia(
    gallery,
    variant.featured_media.id
  );
}


/* ==========================================================================
   Product URL
   ========================================================================== */

function updatePPProductURL(variant) {
  if (!variant || !variant.id) return;

  const url = new URL(window.location.href);

  url.searchParams.set('variant', variant.id);

  window.history.replaceState(
    {},
    '',
    url.toString()
  );
}


/* ==========================================================================
   Money Formatting
   ========================================================================== */

function formatPPMoney(cents) {
  const value = Number(cents);

  if (Number.isNaN(value)) {
    return '';
  }

  const currency =
    window.Shopify?.currency?.active || 'USD';

  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      {
        style: 'currency',
        currency: currency
      }
    ).format(value / 100);
  } catch (error) {
    return `$${(value / 100).toFixed(2)}`;
  }
}